module.exports = "/packs/012-6152037237673a101dced8ddf54259a9.jpg";